import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import type {IGroupUser} from '@netx/core-system-groups/schema';
import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';

export const canLoginAsUser = (user?: IGroupUser) =>
	// DAM-11575 loginAs fails with public user
	user != null &&
	currentUserIsAdmin() &&
	getPublicProperty('viewer.userLogin') !== user.username;
